// src/components/FaqModal/FaqModal.jsx

import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next'; // 1. Import useTranslation and Trans
import './FaqModal.css';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ChatIcon from '@mui/icons-material/Chat';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const FaqModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation(); // 2. Initialize the hook
  const [copied, setCopied] = useState(false);
  const emailAddress = "support@vetra-ai.com";

  if (!isOpen) return null;

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(emailAddress).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    }).catch(err => {
      console.error('Failed to copy email: ', err);
    });
  };

  // Split the "findAssistant" string to insert the icon
  const findAssistantParts = t('faqModal.findAssistant').split('(chat_icon)');

  return (
    <div
      className={`faq-modal-overlay ${isOpen ? 'open' : ''}`}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="faq-modal-title"
    >
      <div className="faq-modal-content" onClick={(e) => e.stopPropagation()}>
        <IconButton
          aria-label={t('faqModal.closeAriaLabel')} // 3. Use t() for aria-label
          onClick={onClose}
          className="faq-modal-close-button"
        >
          <CloseIcon />
        </IconButton>
        <h2 id="faq-modal-title">{t('faqModal.title')}</h2>
        
        {/* 4. Use the <Trans> component for the intro text */}
        <p>
          <Trans i18nKey="faqModal.intro">
            For common questions and immediate assistance, we encourage you to use our new <strong>AI Assistant</strong>!
          </Trans>
        </p>
        
        <p>
          {findAssistantParts[0]}
          {' ('}
          <ChatIcon className="chat-icon-inline-mention" />
          {') '}
          {findAssistantParts[1]}
        </p>
        
        <p>
          {t('faqModal.contactSupport')}
        </p>

        <div className="faq-modal-email-section">
          <div className="faq-modal-email-paragraph">
            <span className="email-and-copy-container">
              <a href={`mailto:${emailAddress}`} className="faq-modal-email-link">
                {emailAddress}
              </a>
              <IconButton
                aria-label={t('faqModal.copyEmailAriaLabel')} // 5. Use t() here
                onClick={handleCopyEmail}
                className="faq-modal-copy-button"
                size="small"
              >
                <ContentCopyIcon fontSize="inherit" />
              </IconButton>
            </span>
            {copied && <span className="copy-feedback">{t('faqModal.copiedFeedback')}</span>}
          </div>
        </div>

      </div>
    </div>
  );
};

export default FaqModal;